import React, { useRef, useState } from "react"
import { Box, makeStyles, useTheme, useMediaQuery, TextField, InputAdornment } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import SearchIcon from "@material-ui/icons/Search"
import Highlighter from "react-highlight-words"
import { useQueryTrainingModules } from "../../data"
import TimeAgo from "../TimeAgo"
import { PaperBox } from "../Boxes"

const useStyles = makeStyles((theme) => ({
  heading: {
    color: theme.palette.kb.heading,
    textAlign: "center",
  },
  searchInput: {
    backgroundColor: theme.palette.kb.searchInput.background,
    height: 56,
  },
  highlight: {
    fontWeight: "600",
    marginLeft: 0,
  },
  date: {
    fontSize: 12,
    color: theme.palette.text.light,
    whiteSpace: "nowrap",
  },
}))

const useInputStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    fontSize: 16,
    color: "black",
    marginBottom: ({ mb }) => (mb ? theme.spacing(mb) : 0),
  },
  notchedOutline: {
    borderColor: "#d2d2d2",
  },
}))

const TrainingModuleSearch = ({ placeholder = "Search training modules...", onItemSelected }) => {
  const theme = useTheme()
  const xs = useMediaQuery(theme.breakpoints.down("xs"))
  const classes = useStyles()
  const inputClasses = useInputStyles()
  const { data, loading } = useQueryTrainingModules()
  const [open, setOpen] = useState(false)
  const clearRef = useRef(false)
  const [searchText, setSearchText] = useState("")

  const handleInputChange = (event, newValue) => {
    setSearchText(newValue)
  }

  const handleChange = (event, option) => {
    if (option?.id) {
      clearRef.current = !clearRef.current
      onItemSelected && onItemSelected(option)
      setSearchText("")
    }
  }

  const modules = (data && data.trainingModules) || []

  return (
    <Autocomplete
      key={clearRef.current}
      freeSolo
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      onInputChange={handleInputChange}
      onChange={handleChange}
      filterOptions={(options) => options}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={({ name }) => name}
      options={modules}
      loading={loading}
      PaperComponent={PaperBox}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          margin="none"
          variant="outlined"
          className={xs ? null : classes.searchInput}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            classes: inputClasses,
            type: "text",
          }}
          data-cy="TrainingModuleSearch-input"
        />
      )}
      renderOption={(option) => (
        <Box display="flex" flexDirection="row" alignItems="center" flexGrow={1} data-cy="TrainingModuleSearch-option">
          <Box>
            <Highlighter
              highlightClassName={classes.highlight}
              searchWords={searchText.split(" ")}
              autoEscape
              textToHighlight={option.name}
            />
          </Box>
          {option.date && (
            <Box ml="auto" pl={1} display="flex" className={classes.date}>
              <TimeAgo date={option.date} />
            </Box>
          )}
        </Box>
      )}
    />
  )
}

export { TrainingModuleSearch }
